<template>
  <div class="category-filter">
    <div class="d-flex align-items-center justify-content-between">
      <div v-if="showCount" class="category-filter-count-wrap fw-bold fs-eyebrow" aria-live="polite">
        <slot name="category-filter-count-prefix" :currentSelection="currentSelection"></slot>
        <span class="filter-count category-filter-count">{{ results ? results.length : '' }}</span>
        <slot name="category-filter-count-suffix" :currentSelection="currentSelection"></slot>
      </div>
      <div v-if="currentQuery.category">
        <button class="bg-transparent border-0 ps-0 py-2 py-lg-1 link-black text-decoration-underline" 
                @click="clearCategory">
          <slot name="category-filter-clear"></slot>
        </button>
      </div>      
    </div>
    <div class="pb-3">
      <button class="btn btn-link text-black w-100 text-start my-2 ps-0 border-0 fs-large fw-medium caret-large caret-lg-base" 
              data-bs-toggle="collapse" 
              data-bs-target="#category-filter-list" 
              aria-expanded="true" 
              aria-controls="category-filter-list"
              v-html="filterData.title">
      </button>
      <div class="collapse" id="category-filter-list" ref="collapse">
        <div v-for="filter in filterData.items">
          <button :class="'bg-transparent border-0 ps-0 py-2 py-lg-1 link-black text-decoration-underline text-start ' + (currentQuery.category == filter.value ? 'fw-medium' : '')" 
                  :data-category="filter.value" 
                  @click="selectCategory"
                  v-html="filter.title">
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Collapse } from 'bootstrap';

  export default {
    props: ['results', 'currentQuery', 'filterData', 'showCount'],
    computed: {
      currentSelection() {
        return this.filterData.items.find((f) => f.value == this.currentQuery.category)?.title
      }
    },
    methods: {
      clearCategory() {
        this.collapse.show()
        this.currentQuery.category = null;
        this.$emit('categoryChange');
      },
      selectCategory(evt) {
        this.collapse.hide();
        this.currentQuery.category = evt.currentTarget.getAttribute('data-category')
        this.$emit('categoryChange');
      }
    },
    emits: ['categoryChange'],
    mounted() {
      this.collapse = new Collapse(this.$refs.collapse, { toggle: !this.currentQuery.category });
    }
  }
</script>